// extracted by mini-css-extract-plugin
module.exports = {"standardContentBlock":"TextAndLinks-module--standardContentBlock--Lb1L1","links":"TextAndLinks-module--links--19WLm","link":"TextAndLinks-module--link--1LYTx"};